import React, { useState } from 'react';

import { Box, Button, Chip, Divider, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Alert from '@mui/material/Alert';

import { useAuth } from '../../AuthContext';
import { Utils } from '../../utils/utils';

// services
import { getKitchenDetails } from '../../services/kitchenService';

export default function ChefContactInformation(props) {
  const { auth } = useAuth();
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [kitchenInfo, setKitchenInfo] = useState(null);
  const chefFullName = [kitchenInfo?.chef?.firstName, kitchenInfo?.chef?.lastName]
    .filter(Boolean)
    .join(' ') || 'N/A';

  const handleClickOpen = () => {
    getKitchenDetails(props.kitchenId, auth).then((kitchenDetails) => {
      if (kitchenDetails) {
        setKitchenInfo(kitchenDetails);
      }
    }).catch(() => {
      setError(true);
    });

    setOpen(true);
  };

  const handleClose = () => {
    setError(false);
    setOpen(false);
  };

  return (
    <Box>
      <label 
        onClick={handleClickOpen}
        style={{ 
          color: '#1976d2', 
          cursor: 'pointer', 
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          fontWeight: 500
        }}
      >
        Chef Information
      </label>
      
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        { error ? (<Alert severity="error">Sorry, an error occurred while retrieving data!</Alert>) : ''}
        <DialogTitle id="responsive-dialog-title" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <Typography variant="h6">Chef Contact Information</Typography>
        </DialogTitle>
        <DialogContent sx={{ px: 2 }}>
          <DialogContentText sx={{ m: 0 }}>
            <Box sx={{ minWidth: { xs: '100%', sm: 420 } }}>
              <Box sx={{ p: 1.5, borderRadius: 2, border: 1, borderColor: 'divider', backgroundColor: 'background.paper' }}>
                <Box sx={{ mb: 1.5 }}>
                  <Typography variant="caption" color="text.secondary">Kitchen:</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>{kitchenInfo?.name || 'N/A'}</Typography>
                </Box>

                <Box sx={{ mb: 1.5 }}>
                  <Typography variant="caption" color="text.secondary">Chef:</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>{chefFullName}</Typography>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary">Phone:</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>{kitchenInfo?.phoneNumber ? Utils.formatPhoneNumber(kitchenInfo.phoneNumber) : 'N/A'}</Typography>
                </Box>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 2 }}>
          <Button autoFocus onClick={handleClose} style={{ textTransform: 'none'}} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
